export default __webpack_public_path__ + "static/media/favicon.59a09235.ico";